import { gql } from "@apollo/client";

export default gql`
  query getProfileCandidateMeetingsQuery(
    $participants: [Int!]!
    $nextAfterDate: DateTime!
  ) {
    candidateMeetings: meetings(
      participants: $participants
      participantCount: 2
      isFormalOneonone: false
      startDatetime_Gte: $nextAfterDate
      first: 20
      orderBy: "start_datetime"
    ) {
      edges {
        node {
          id
          title
          startDatetime
          meetingGroupId
        }
      }
    }
  }
`;
